module.exports = __webpack_public_path__ + "static/media/icon-search.cd161a5d.svg";